import React, { useEffect } from 'react';

function ContatoBioClinica() {
  useEffect(() => {
    // Redireciona para WhatsApp assim que o componente monta
    window.location.href = 'https://wa.me/5521964661537?text=Ol%C3%A1!%20Vim%20da%20bio%20da%20Clinica%20Lumi%20One%20e%20quero%20saber%20mais!';
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p>Redirecionando para WhatsApp...</p>
    </div>
  );
}

export default ContatoBioClinica;
